var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "count" },
    [
      _c(
        "b",
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("registration.flight-suggestions-count-1")) +
              "\n        "
          ),
          _vm.searchSuggestion
            ? [_vm._m(0)]
            : [
                _vm._v(
                  "\n            " + _vm._s(_vm.nbSuggestion) + "\n        "
                )
              ],
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("registration.flight-suggestions-count-2")) +
              "\n    "
          )
        ],
        2
      ),
      _vm._v(" "),
      !_vm.searchSuggestion && _vm.nbSuggestion > 0
        ? [
            _c("font", { attrs: { size: "3" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("registration.flight-suggestions-alt", {
                    price: parseInt(_vm.suggestionMinPrice.totalPriceHt),
                    nbPassenger: _vm.suggestionMinPrice.nbPassengers
                  })
                )
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0594e90a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0594e90a","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/suggestion-planes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0594e90a","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/suggestion-planes.vue
// module chunks = 1 2 3